import { createDataHook } from "../../helpers/util";
import { GOOGLE_CHARTS_TYPES } from "../../consts/graphs";
import dashboardAdminAPIsService from "../dashboardAdminAPIs";

const useFetchManagerDashboardData = createDataHook(
  dashboardAdminAPIsService,
  (filters, params, controller, apiService = dashboardAdminAPIsService) => ({
    fetchSummaryCardsData: () =>
      apiService.fetchSummaryCardsData(filters, controller.signal),
    fetchUsersComplianceTrendData: () =>
      apiService.fetchUsersComplianceTrendData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.AREACHART },
        controller.signal
      ),
    fetchUsersCompliancePercentageData: () =>
      apiService.fetchUsersCompliancePercentageData(params, controller.signal),
    /*fetchNumberOfEmployeesOverdueData: () =>
      apiService.fetchNumberOfEmployeesOverdueData(params, controller.signal),*/
    fetchCourseCompletionByMonthData: () =>
      apiService.fetchCourseCompletionByMonthData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.COLUMNCHART },
        controller.signal
      ),
    fetchActiveUsersNeverLoggedInData: () =>
      apiService.fetchActiveUsersNeverLoggedInData(params, controller.signal),
    fetchEstimatedHoursSpentOnElearningData: () =>
      apiService.fetchEstimatedHoursSpentOnElearningData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.COLUMNCHART },
        controller.signal
      ),
    fetchMostLeastCompliantCoursesData: () =>
      apiService.fetchMostLeastCompliantCoursesData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.BARCHART },
        controller.signal
      ),
    /*fetchDocumentsOutstandingData: () =>
      apiService.fetchDocumentsOutstandingData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.BARCHART },
        controller.signal
      ),*/
    fetchLoginsByDayData: () =>
      apiService.fetchLoginsByDayData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.BAR },
        controller.signal
      ),
    fetchLoginsByMonthData: () =>
      apiService.fetchLoginsByMonthData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.BAR },
        controller.signal
      ),
    fetchLoginsByTimeData: () =>
      apiService.fetchLoginsByTimeData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.AREACHART },
        controller.signal
      ),
  }),
  { preflight: "admin" }
);

export default useFetchManagerDashboardData;
